import React, { useState, useEffect } from "react";
import "./Hero.css";
import { FaMapMarkerAlt, FaCalendarAlt, FaFlag } from "react-icons/fa";

export default function Hero() {
  const mediaList = [
    { type: "video", src: "/assets/v1.mp4" },
    { type: "video", src: "/assets/v3.mp4" },
    { type: "video", src: "/assets/v2.mp4" }
    
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % mediaList.length);
    }, 3000); // 5 sec

    return () => clearInterval(interval);
  }, [mediaList.length]);

  return (
    <section className="hero">
      {/* Background media */}
      <div className="background-wrapper">
        {mediaList.map((media, index) => (
          <div
            key={index}
            className={`background-slide ${
              index === currentIndex ? "active" : ""
            }`}
          >
            {media.type === "video" ? (
              <video autoPlay loop muted playsInline>
                <source src={media.src} type="video/mp4" />
              </video>
            ) : (
              <img src={media.src} alt="background" />
            )}
          </div>
        ))}
      </div>

      {/* Dark Overlay */}
      <div className="overlay">
        <div className="hero-content">
          <h3 className="tagline">extra-ordinary</h3>
          <h1 className="title">Your Journey Begins</h1>
          <p className="subtitle">
            A journey of a 1000 miles starts with a single step. Import the full
            demo content with 1 click and create a head-turning website for your
            travel agency.
          </p>

          {/* Search Box */}
          <div className="search-main">
            <div className="search-box">
              <div className="search-item">
                <FaMapMarkerAlt className="icon" />
                <span>WHERE TO?</span>
              </div>
              <div className="search-item">
                <FaCalendarAlt className="icon" />
                <span>WHEN?</span>
                <span className="dropdown">&#9662;</span>
              </div>
              <div className="search-item">
                <FaFlag className="icon" />
                <span>TRAVEL TYPE</span>
                <span className="dropdown">&#9662;</span>
              </div>
              <button className="search-btn">FIND NOW</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
